import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { SupplierCreate } from './components/SupplierCreate/SupplierCreate';
import { SupplierList } from './components/SupplierList/SupplierList';
import { SupplierProfile } from './components/SupplierProfile/SupplierProfile';

export const SuppliersPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<SupplierList />} />
      <Route path="create" element={<SupplierCreate />} />
      <Route path=":supplierId" element={<SupplierProfile />} />
    </Routes>
  );
};
